
import authService from "../services/authService";
import styles from "./checkoutlayout.module.css";
import { Banner, BreadCrumb, Stepper, SubHeadingTitle } from "./shared/index";
import { Outlet, useLocation } from "react-router-dom";
import { useLayoutEffect, useRef } from "react";
import { useEffect } from "react";
const CheckoutLayout = () => {
  const { pathname } = useLocation();
  const isLoggedin = authService.isLoggedIn();
 const stepperRef = useRef(null);





useLayoutEffect(() => {
  if (stepperRef.current) {
    const stepperTop =
      stepperRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      120; // navbar height

    window.scrollTo({
      top: stepperTop,
      behavior: "instant",
    });
  }
}, [pathname]);
const steps = [
  { number: 1, label: "Shopping Cart" },
  { number: 2, label: "Address Checkout" },
  { number: 3, label: "Shopping & Payment" },
  { number: 4, label: "Complete" },
];
const currentStepMapping = {
  cart: 1,
  checkout: 2,
  address: 2,
  payment: 3,
  success: 4,
   "order-success": 4,
};
  const lastPart = pathname.split("/").pop();
  const currentStep = currentStepMapping[lastPart] || 1;

  const pageConfig = {
    cart: {
      breadcrumbLabel: "Shopping Cart",
      bannerHeading: "Quality healthcare products delivered to your doorstep",
      bannerImage:
        "https://t3.ftcdn.net/jpg/09/12/83/30/240_F_912833087_PfQGVPf6nfk1ablZpIhajFzKnOGYKQFI.jpg",
    },
    checkout: {
      breadcrumbLabel: "Address Checkout",
      bannerHeading: "Quality healthcare products delivered to your doorstep", 
      bannerImage:
        "https://t4.ftcdn.net/jpg/05/15/80/09/240_F_515800945_SK7WwuVKA8xAIMkLJFTkjj1RqNrEBkJE.jpg"
    }, 
    prescription: {
  breadcrumbLabel: "Upload Prescription",
  bannerHeading: "Upload your prescription for verification",
  bannerImage:
    "https://media.gettyimages.com/id/149262483/photo/close-up-of-doctors-hand-giving-prescription-to-patient-studio-shot.jpg?s=612x612&w=0&k=20&c=nfpBJNywH5JvH_x5gjYhvZC2eXQzYgwT_PZ89yGAFfM=",
},
    payment: {
      breadcrumbLabel: "Shipping & Payment Summary",
      bannerHeading: "Quality healthcare products delivered to your doorstep",
      bannerImage:
          "https://t4.ftcdn.net/jpg/07/43/05/01/240_F_743050189_ZUngBiSqkCY5NmhWNZZT2FjykdpPHUwX.jpg",
    },
    success: {
      breadcrumbLabel: "Product Tracking",
      bannerHeading: "Same Day Delivery . multiple payment options",
      bannerImage:
        "https://media.istockphoto.com/id/960871382/photo/assortment-of-the-fresh-vegetables.jpg?s=612x612&w=0&k=20&c=wUJcQBMWzoxwS_WNhCeoS0HaSMfS7IAHO_9uIg7WK0c=",
    },
  };

  const key = pathname.split("/").pop();
  const config = pageConfig[key] || pageConfig["checkout"];

  return (
    <div className={styles.checkoutWrapper}>
      <BreadCrumb
        customPaths={[{ label: config.breadcrumbLabel, path: "/" }]}
      />
      <Banner heading={config.bannerHeading} imageUrl={config.bannerImage} />
      {!isLoggedin ? (
         <SubHeadingTitle
              subTitle={
                "Please login to check cart items & proceed to checkout..."
              }
              style={styles.cartError}
            />
      ) :  
     <>
       <div ref={stepperRef}>
  <Stepper
    steps={steps}
    currentStep={currentStep}
  />
</div>

<Outlet />
     </>
      }
    </div>
  );
};

export default CheckoutLayout;